import { gql } from '@apollo/client';

const EDIT_PHYSICIAN_INTERPRETATION_MUTATION = gql`
  mutation editPhysicianInterpretation($id: ID!, $interpretation: String!, $signature: String) {
    editPhysicianInterpretation(id: $id, interpretation: $interpretation, signature: $signature) {
      isSuccess
      message
    }
  }
`;

export default EDIT_PHYSICIAN_INTERPRETATION_MUTATION;
